import { pxToRem } from '@archipro-design/aria';
import {
    NavigationList,
    Flex,
    useStyles,
    Caption,
} from '@archipro-design/aria';
import { Link } from '@remix-run/react';
import * as S from './SubFooter.style';
import type { SubfooterCategory } from '../../type';
import type { SubFooterProps } from './SubFooter';

export const SubFooterDesktop = (props: SubFooterProps) => {
    const { categories } = props;
    const { css } = useStyles();

    return (
        <Flex className={css(S.SubFooterDesktopStyle)}>
            {categories.map((category: SubfooterCategory, i: number) => {
                const { moreButton, title, items } = category;
                return (
                    <NavigationList
                        key={i}
                        defaultItemSize={16}
                        items={items.map((item) => {
                            return {
                                as: Link,
                                ...item,
                            };
                        })}
                        moreButton={{
                            children: (
                                <Caption variant="03" weight="medium">
                                    View all
                                </Caption>
                            ),
                            as: Link,
                            to: moreButton.to,
                        }}
                        title={{
                            children: title,
                            weight: 'medium',
                            variant: '03',
                            uc: true,
                        }}
                        variables={{
                            listWidth: pxToRem(278),
                            optionMoreButtonGap: pxToRem(50),
                            titleMinHeight: 'unset',
                        }}
                    />
                );
            })}
        </Flex>
    );
};
